import { useState } from 'react';
import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import MoversFeature from 'features/movers';
import {
  ButtonExpand,
  Container,
  HeaderContainer,
  ModalContentContainer,
  ModalMovers,
} from './styled';
import { MoverFilterType, MoverType } from '../../../../../@types/movers';

const { Text } = Common;

const Movers = () => {
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState<MoverFilterType[]>([
    'FILTER_STOCKS_TYPE_MAIN_BOARD',
    'FILTER_STOCKS_TYPE_DEVELOPMENT_BOARD',
    'FILTER_STOCKS_TYPE_ACCELERATION_BOARD',
    'FILTER_STOCKS_TYPE_NEW_ECONOMY_BOARD',
  ]);

  return (
    <Container>
      <HeaderContainer>
        <Text weight="700">Movers</Text>
        <ButtonExpand onClick={() => setShowModal(true)}>
          <Image src="/icon/maximize.svg" />
        </ButtonExpand>
      </HeaderContainer>
      <div id="movers-wrapper">
        <MoversFeature
          featureKey="sidewidget"
          filter={filter}
          setFilter={setFilter}
        />
      </div>
      <ModalMovers
        width={940}
        bodyStyle={{
          height: 700,
        }}
        title={
          <Text p="20px 12px 12px 20px" size="18px" weight="700">
            Movers
          </Text>
        }
        centered
        visible={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
      >
        <ModalContentContainer>
          <MoversFeature
            featureKey="modal"
            filter={filter}
            setFilter={setFilter}
          />
        </ModalContentContainer>
      </ModalMovers>
    </Container>
  );
};

export default Movers;
